export default "__VITE_ASSET__BF4VcPdf__"